"use client";
import { useEffect } from "react";

const IntercomComponent: React.FC = () => {
  useEffect(() => {
    window.intercomSettings = {
      app_id: "h4qkzypg",
    };

    if (window.Intercom) {
      window.Intercom("reattach_activator");
      window.Intercom("update", window.intercomSettings);
    } else {
      window.addEventListener("load", () => {
        const script = document.createElement("script");
        script.src = "https://widget.intercom.io/widget/h4qkzypg";
        script.async = true;
        document.body.appendChild(script);
      });
    }
  }, []);

  return null;
};

export default IntercomComponent;
